import React, { useState } from 'react'
import photo1 from '../../../../images/relocation/image1.jpg'
import photo2 from '../../../../images/relocation/image2.jpg'
import photo3 from '../../../../images/relocation/image3.jpg'
import photo4 from '../../../../images/relocation/image4.jpg'
import photo5 from '../../../../images/relocation/image5.jpg'
import photo6 from '../../../../images/relocation/image6.jpg'
import photo7 from '../../../../images/relocation/image7.jpg'
import photo8 from '../../../../images/relocation/image8.jpg'
import photo9 from '../../../../images/relocation/image9.jpg'

import circle_green from '../../../../images/main/greenIcon.svg'
import circle from '../../../../images/main/curcle.svg'

import styles from './styles.module.scss'

const LiveInVolginsky = () => {
  const [activeCity, setActiveCity] = useState(0)
  const city = ['Туризм', 'Гастрономия', 'Спорт']
  return (
    <div className={styles.wrapper}>
      <div className={styles.wrapper_block}>
        <div className={styles.leftSide}>
          <div>
            <p className={styles.title}>Жизнь в биотехнопарке в поселке Вольгинском</p>
            <p className={styles.text}>Новые впечатления<br/>на новом месте</p>
            <div className={styles.wrapper_list}>
              {city.map((item, index) => (
                <div className={styles.list} key={index}>
                  <svg
                    width='8'
                    height='8.5'
                    viewBox='0 0 8 9'
                    xmlns={activeCity === index ? circle_green : circle}
                    className={activeCity === index ? styles.circle_active : styles.circle}
                  >
                    <path d='M0.00316702 3.8519C-0.00589703 2.92909 -0.0104292 2.46768 0.21048 2.08978C0.431389 1.71189 0.838278 1.48501 1.65205 1.03126L2.28831 0.676488C3.10208 0.222733 3.50897 -0.00414446 3.95826 5.73045e-05C4.40754 0.00425907 4.81896 0.238789 5.6418 0.70785L6.28514 1.07459C7.10798 1.54365 7.5194 1.77818 7.74778 2.16027C7.97615 2.54237 7.98068 3.00378 7.98975 3.92659L7.99683 4.6481C8.0059 5.57091 8.01043 6.03232 7.78952 6.41022C7.56861 6.78811 7.16172 7.01499 6.34794 7.46874L5.71169 7.82351C4.89792 8.27727 4.49103 8.50414 4.04174 8.49994C3.59246 8.49574 3.18104 8.26121 2.3582 7.79215L1.71486 7.42541C0.892017 6.95635 0.480598 6.72182 0.252224 6.33973C0.0238499 5.95763 0.0193178 5.49622 0.0102538 4.57341L0.00316702 3.8519Z' />
                  </svg>
                  <p
                    onClick={() => setActiveCity(index)}
                    className={activeCity === index ? styles.title_name_active : styles.title_name}
                  >
                    {item}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className={styles.rightSide}>
          <div className={styles.rightSide_wrapper}>
            <p className={styles.text}>Новые впечатления<br/>на новом месте</p>
            <div className={styles.rightSide_wrapper_scroll_box}>
              <div className={styles.rightSide_wrapper_block}>
                <div className={styles.rightSide_wrapper_block_item}>
                  <div>
                    <p className={styles.rightSide_wrapper_block_item_p1}>
                      {activeCity === 0
                        ? 'Белокаменное наследие России'
                        : activeCity === 1
                        ? 'Фермерские продукты'
                        : activeCity === 2
                        ? 'Здоровый образ жизни'
                        : null}
                    </p>
                    <p className={styles.rightSide_wrapper_block_item_p2}>
                      {activeCity === 0
                        ? 'Посетите церкви Суздаля и Владимира'
                        : activeCity === 1
                        ? 'Доставка яиц, молока и мяса'
                        : activeCity === 2
                        ? 'Спортивные залы, гимнастика, теннисные корты, бассейн и площадка для кроссфита'
                        : null}
                    </p>
                  </div>
                  <img
                    draggable='false'
                    src={activeCity === 0 ? photo9 : activeCity === 1 ? photo3 : activeCity === 2 ? photo6 : photo9}
                    alt='photo'
                  />
                </div>

                <div className={styles.rightSide_wrapper_block_item}>
                  <div>
                    <p className={styles.rightSide_wrapper_block_item_p1}>
                      {activeCity === 0
                        ? 'Наши северные друзья'
                        : activeCity === 1
                        ? 'Voloza Luxury Village'
                        : activeCity === 2
                        ? 'Спортивные секции'
                        : null}
                    </p>
                    <p className={styles.rightSide_wrapper_block_item_p2}>
                      {activeCity === 0
                        ? 'Оленья ферма и питомник хаски'
                        : activeCity === 1
                        ? 'Ресторан домашней и авторской кухни в 10 минутах езды'
                        : activeCity === 2
                        ? 'По волейболу, футболу и баскетболу'
                        : null}
                    </p>
                  </div>
                  <img
                    draggable='false'
                    src={activeCity === 0 ? photo1 : activeCity === 1 ? photo4 : activeCity === 2 ? photo7 : photo1}
                    alt='photo'
                  />
                </div>

                <div className={styles.rightSide_wrapper_block_item}>
                  <div>
                    <p className={styles.rightSide_wrapper_block_item_p1}>
                      {activeCity === 0
                        ? 'Красоты природы'
                        : activeCity === 1
                        ? 'Ресторан Bon Appetit'
                        : activeCity === 2
                        ? 'Сезонные мероприятия'
                        : null}
                    </p>
                    <p className={styles.rightSide_wrapper_block_item_p2}>
                      {activeCity === 0
                        ? 'Введенская пустынь и Черное озеро'
                        : activeCity === 1
                        ? 'Уютное место с открытой верандой на территории академгородка'
                        : activeCity === 2
                        ? 'Каток и лыжня — зимой, велопрогулки и сплавы — летом'
                        : null}
                    </p>
                  </div>
                  <img
                    draggable='false'
                    src={activeCity === 0 ? photo2 : activeCity === 1 ? photo5 : activeCity === 2 ? photo8 : photo2}
                    alt='photo'
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LiveInVolginsky
